import autobind from 'autobind-decorator'
import * as React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Icon, Input, Button, Dropdown, Menu, Row, Col, Divider, Tooltip } from 'antd'
import { connect } from 'redux-scaffolding-ts'
import { Link, RouteComponentProps, withRouter } from 'react-router-dom'
import { TimesheetsStore, TimesheetSummary } from 'src/stores/timesheets-store'
import { Query, ItemState, DataStore } from 'src/core/stores/dataStore'
import { TableModel, TableView } from 'src/core/ui/collections/table'
import { formatMessage } from 'src/core/services/http.service'
import HttpService from "src/core/services/http.service"
import { resolve } from 'src/inversify.config'
import { CommandResult } from '../../../core/stores/types'
import { formatDateUtc, unixEpochToDate } from '../../../core/utils/object'
import moment from 'moment'
import RangePickerFilter from 'src/components/range-picker-filter'
import ExportParamsView from 'src/components/exportrange-editor'
import { RangePickerValue } from 'antd/lib/date-picker/interface'
import './timesheet-list.less'
import Tour from 'reactour'
import steps from 'src/components/virtual-tour/virtual-tour-configs'
import { withIdentity } from '../../../core/services/authentication'
import NewTimesheetsGeneratorView from 'src/pages/admin/timesheets/timesheets-new'
import EditableTooltip from '../../../components/editable-tooltip/tooltip'
import { CacheProps, withCache } from '../../../core/services/cache.service'
import { CompanyItem } from "src/stores/companies-store";
import { successNotification } from '../../../components/systemNotifications/notificationService'
import { UserProfileProps, withUserProfile } from "../../../components/user-profile";
import { isReadOnly } from 'src/utils/CheckValidationbyUsers'
import { BulkInsertUpload } from '../../../components/bulk-upload/bulkInsert-upload'
import { useDispatch, useSelector } from 'react-redux'
import { refreshTableTimeSheetToggle } from '../../../stores/actions/TimeSheet'
import { ApplicationState } from '../../../stores/reducers'
import { FC } from 'react'

// tslint:disable-next-line:no-empty-interface
interface TimesheetsViewProps extends RouteComponentProps, WithTranslation, UserProfileProps, CacheProps {
    companyId: string,
    companyName: string,
    item: CompanyItem | undefined,
    handleResetTableSuccess?: (value: boolean) => void,
    isRefreshTable?: boolean
}

interface TimesheetsViewState {
    query: Query
    setBusyGenerator: boolean
    newTimesheetShown: boolean
    configureExport: boolean
    exportFormat: string
    isTourOpen: boolean
    isGeneratorActive: boolean
    filterDateVisible?: boolean
    filterDates?: RangePickerValue
    selectedStatusText: string
    selectedItems: any[];
    statusFilter?: string | undefined;
    dateStart?: number | null;
    dateEnd?: number | null;
    defaultCustomDate?: boolean;
    defaultValuesCustomDate?: {
        start: string | null,
        end: string | null
    };
    stateTimesheet: string;
    isEmptyListAndManager: boolean | null;
}

interface SearchRequest {
    format: string;
    start: number;
    end: number;
    status: number;
    column?: string;
    search: string;
    timesheetIds?: string[];
}

interface TimesheetStatusMap {
    [key: string]: number;
}


@connect(['timesheets', TimesheetsStore])
class TimesheetsDashboard extends React.Component<TimesheetsViewProps, TimesheetsViewState> {

    @resolve(HttpService)
    private httpService!: HttpService

    private get timesheetsStore() {
        return (this.props as any).timesheets as TimesheetsStore
    }

    constructor(props: TimesheetsViewProps) {
        super(props)

        var stateStored = props.cache.getWithCustomKey("TimeSheets", true)

        var query = { searchQuery: '', orderBy: [{ field: 'employeeTitle', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 }

        if (stateStored && stateStored.query)
            query = stateStored.query
        this.state = {
            query: query as any,
            newTimesheetShown: stateStored?.newTimesheetShown ? stateStored?.newTimesheetShown : false,
            configureExport: stateStored?.configureExport ? stateStored?.configureExport : false,
            exportFormat: stateStored?.exportFormat ? stateStored?.exportFormat : "standard",
            isTourOpen: false,
            setBusyGenerator: false,
            isGeneratorActive: false,
            filterDateVisible: stateStored?.filterDateVisible,
            filterDates: stateStored?.filterDates ? [moment.utc(stateStored.filterDates[0]), moment.utc(stateStored.filterDates[1])] : undefined,
            selectedStatusText: stateStored?.selectedStatusText ? stateStored?.selectedStatusText : "Status",
            selectedItems: [],
            statusFilter: undefined,
            dateStart: null,
            dateEnd: null,
            stateTimesheet: 'all',
            isEmptyListAndManager: null
        }
        let { t } = props
        this.onSelectChange = this.onSelectChange.bind(this);
    }

    componentDidMount() {
        this.state.isEmptyListAndManager ?  this.load(this.state.query) : this.checkEmployeeExist()
    }

    @autobind
    private async checkEmployeeExist() {
        const employeedExist = await this.timesheetsStore.checkEmployeeExists(this.props.companyId)
        await this.load(this.state.query)
        this.setState({isEmptyListAndManager: employeedExist})
    }

    @autobind
    private checkAuthAdmin() {
        return this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("Administrator") || this.props.userProfile.roles.includes("ClientAdmin") || this.props.userProfile.roles.includes("FIConsultant"))
    }

    @autobind
    private load(query: Query) {
        this.timesheetsStore.setBaseUrl(this.props.companyId)
        this.props.cache.saveWithCustomKey("TimeSheets", this.state)
        this.timesheetsStore.getAllAsync(query)
    }

    @autobind
    private onQueryChanged(query: Query) {
        this.setState({ query }, () => this.load(query))
    }

    @autobind
    private async onDeleteRow(item: TimesheetSummary, state: ItemState): Promise<CommandResult<any>> {
        this.setState({ selectedItems: [] });
        return await this.timesheetsStore.deleteAsync(`${item.id}`)
    }

    @autobind
    private onNewItem() {
        this.setState({ newTimesheetShown: true })
    }

    @autobind
    private onNewItemClosed(id: string | undefined) {
        this.setState({ newTimesheetShown: false })
        this.load(this.state.query)
    }

    @autobind
    private onChangeDatePicker(dates: RangePickerValue) {
        if (dates[0] == undefined && dates[1] == undefined) {
            const query: Query = {
                ...this.state.query,

                filter: this.state.query["filter"] == undefined ? undefined : (Object.keys(this.state!.query["filter"]).includes("Status") ? { "Status": Object.values(this.state!.query["filter"])[Object.keys(this.state!.query["filter"]).indexOf("Status")] } : undefined)
            }
            this.setState({
                query, filterDateVisible: undefined,
                filterDates: undefined,
                dateStart: null,
                dateEnd: null,
                defaultCustomDate: false,
                defaultValuesCustomDate: {
                    start: null,
                    end: null
                }
            }, () => { this.load(query) })
        }
        else {
            const start = moment(dates[0]).isoWeekday() === 1 ? dates[0]: moment(dates[0]).clone().startOf('isoWeek').day('Monday');
            const end = moment(dates[1]).isoWeekday() === 7 ? dates[1] : moment(dates[1]).clone().endOf('isoWeek').day('Sunday');
            const timestampFromDate = start ? moment.utc(start.format("DD-MM-YYYY"), "DD-MM-YYYY").unix() : 0
            const timestampToDate = end ? moment.utc(end.format("DD-MM-YYYY"), "DD-MM-YYYY").endOf("day").unix() : 0
            var filter = this.state.query["filter"] == undefined ? { 'FromDate': { ge: timestampFromDate, le: timestampToDate } } : Object.keys(this.state!.query["filter"]).includes("Status") ? { 'FromDate': { ge: timestampFromDate, le: timestampToDate }, "Status": Object.values(this.state!.query["filter"])[Object.keys(this.state!.query["filter"]).indexOf("Status")] } : { 'FromDate': { ge: timestampFromDate, le: timestampToDate } }
            const startDate = moment(dates[0]).toString();
            const endDate = moment(dates[1]).toString();
            const query: Query = {
                ...this.state.query,
                filter: filter
            }

            this.setState({
                query,
                filterDateVisible: true,
                filterDates: dates,
                dateStart: timestampFromDate,
                dateEnd: timestampToDate,
                defaultCustomDate: true,
                defaultValuesCustomDate: {
                    start: startDate,
                    end: endDate
                }
            }, () => { this.load(query) })
        }
    }

    @autobind
    private onConfigureExport() {
        this.setState({ configureExport: true })
    }

    @autobind
    private cancelExport() {
        this.setState({ configureExport: false })
    }

    @autobind
    private onGenerated(fromDate: number, toDate: number) {
        var self = this
        this.setState({
            isGeneratorActive: false
        })
    }

    @autobind
    private onGenerateTimesheetsClick() {
        this.setState({
            isGeneratorActive: true
        })
    }

    @autobind
    private onGenerateTimesheetsClosed() {
        this.setState({
            isGeneratorActive: false
        })
    }

    @autobind
    private async onExportFormat(format: string) {
        this.setState({ exportFormat: format })
        this.onConfigureExport()
    }

    @autobind
    private onStatusFilter(status: string) {

        if (status != 'all') {
            var filter = this.state.query["filter"] == undefined ? { 'Status': { eq: status, } } : (Object.keys(this.state!.query["filter"]).includes("FromDate") ? { 'FromDate': Object.values(this.state!.query["filter"])[Object.keys(this.state!.query["filter"]).indexOf("FromDate")], 'Status': { eq: status, } } : { 'Status': { eq: status, } })
            const query: Query = {
                ...this.state.query,
                filter: filter
            }

            this.setState({ query, selectedStatusText: status, statusFilter: status, stateTimesheet: status }, () => this.load(query))
        } else {
            const query: Query = {
                ...this.state.query,
                filter: this.state.query["filter"] == undefined ? undefined : (Object.keys(this.state!.query["filter"]).includes('FromDate') ? { 'FromDate': Object.values(this.state!.query["filter"])[Object.keys(this.state!.query["filter"]).indexOf("FromDate")] } : undefined),
            }
            this.setState({ query, selectedStatusText: "Status", stateTimesheet: 'all' }, () => this.load(query))
        }
    }

    @autobind
    private setIsTourOpen(state: boolean) {
        this.setState({ isTourOpen: state })
    }

    private onSelectChange = (selectedRowKeys: any[]) => {
        this.setState({ selectedItems: selectedRowKeys });
    }

    private TimesheetStatus: TimesheetStatusMap = {
        Draft: 0,
        Pending: 1,
        Approved: 2,
        Rejected: 3,
        all: 99,
    };

    public getTimesheetStatusValue = (key: keyof TimesheetStatusMap): number => {
        return this.TimesheetStatus[key];
    }

    private downloadExcel = async (start: number, end: number, format: string) => {
        const { query, stateTimesheet } = this.state;
        const status = this.getTimesheetStatusValue(stateTimesheet);
        const search = query?.parameters?.$search?.toString() ? query?.parameters?.$search?.toString() : '';
        const options: SearchRequest = {
            search,
            status,
            format,
            start,
            end,
        };

        await this.httpService.post(`api/v1/admin/companies/${this.props.companyId}/timesheets/exportTimeSheet`, options, {
            responseType: 'arraybuffer'
        });
        this.cancelExport();
        successNotification(this.props.t('Operation Completed Successfully'), this.props.t('Your operation will be processed in background.'))
    }

    private downloadExcelTimesheet = async (format: string, period: string, isAll: boolean = false) => {
        const { query, stateTimesheet, dateStart, dateEnd } = this.state;
        const search = query?.parameters?.$search?.toString() ? query?.parameters?.$search?.toString() : '';
        const status = this.getTimesheetStatusValue(stateTimesheet);
        const selectedItems = this.state.selectedItems;
        let start = dateStart;
        let end = dateEnd;

        if (period === 'isoWeek') {
            start = moment().startOf('week').unix();
            end = moment().endOf('week').unix();
        }
        else if (period === 'month') {
            start = moment().startOf('month').unix();
            end = moment().endOf('month').unix();
        }

        const options: SearchRequest = {
            start: start ? start : 0,
            end: end ? end : 0,
            format,
            status,
            search,
        };

        if (selectedItems.length > 0) {
            options.timesheetIds = selectedItems;
        }

        const apiEndpoint = isAll ? 'exportTimesheetStandard' : 'exportTimeSheet';

        await this.httpService.post(`api/v1/admin/companies/${this.props.companyId}/timesheets/${apiEndpoint}`, options, {
            responseType: 'arraybuffer'
        });

        !isAll && this.cancelExport();

        successNotification(this.props.t('Operation Completed Successfully'), this.props.t('Your operation will be processed in background.'))
    }

    public render() {
        const { t } = this.props as any

        if (this.props.isRefreshTable) {            
            this.load(this.state.query);
            if (this.props.handleResetTableSuccess) {
                this.props.handleResetTableSuccess(false);
            }           
        }

        const tableModel = {
            query: this.state.query,
            columns: [
                {
                    sortable: true,
                    field: 'employeeTitle',
                    title: t('Employee'),
                    renderer: (data) => <span>
                        <Link data-tut="reactour__selectTimesheet" to={{
                            pathname: `/time-tracking/admin/companies/${this.props.companyId}/employees/${data.employeeId}/timesheets/${data.id}`,
                            state: {
                                titles: [...(this.props.location.state ? (this.props.location.state as any).titles || [] : []),
                                    { url: `/time-tracking/admin/companies/${this.props.companyId}`, title: this.props.companyName },
                                    { url: `/time-tracking/admin/companies/${this.props.companyId}/employees/${data.employeeId}`, title: data.employeeTitle },
                                    { url: `/time-tracking/admin/companies/${this.props.companyId}/employees/${data.employeeId}/timesheets/`, title: t('timesheets'), search: "?tab=timesheets" }]
                            }
                        }}>
                            <Icon type="cluster" />&nbsp;<span>{data.employeeTitle.split('(')[0]}</span><span style={{ fontSize: 12 }}>({data.employeeTitle.split('(')[1]}</span>
                        </Link>
                    </span>,
                    editor: () => <Input />
                },
                {
                    sortable: true,
                    field: 'dateFrom',
                    title: t('From'),
                    renderer: (data) => <span>{formatDateUtc(moment(unixEpochToDate(data.fromDate)).toDate())}</span>,
                    editor: () => <Input />
                },
                {
                    sortable: true,
                    field: 'dateTo',
                    title: t('To'),
                    renderer: (data) => <span>{formatDateUtc(moment(unixEpochToDate(data.toDate)).toDate())}</span>,
                },
                {
                    sortable: false,
                    field: 'status',
                    title: t('Status'),
                    renderer: (data) => <span>{t(data.status)}</span>,
                },
                {
                    sortable: true,
                    field: 'progress',
                    align: 'center',
                    title: <EditableTooltip name="timesheet-list-progress"> {t('Progress')} </EditableTooltip>,
                    renderer: (data) => <span>{`${(data.percentage ? data.percentage.toFixed(2) : 0)}%`}</span>,
                },
                {
                    field: 'employeeRestrictionPlan',
                    align: 'center',
                    title: t('Restriction Plan'),
                    renderer: (data: TimesheetSummary) => <span>{data.employeeRestrictionPlan}</span>
                }
            ],
            data: this.timesheetsStore.state,
            sortFields: [{
                field: 'employeeTitle',
                text: t('Employee'),
                useProfile: true
            },
                {
                    field: 'dateFrom',
                    text: t('From'),
                    useProfile: true
                },
                {
                    field: 'dateTo',
                    text: t('To'),
                    useProfile: true
                },
                {
                    field: 'progress',
                    text: t('Progress'),
                    useProfile: true
                }],
        } as TableModel<TimesheetSummary>

        const hasSelected = tableModel.data.items.some((x) => this.state.selectedItems.some(t => t == (x.item as any)['id']));

        const downloadOptions = <Menu>
            {this.props.item?.standardReport && < Menu.Item onClick={(e: any) => this.onExportFormat('standard')}>{t('Standard Format')}</Menu.Item>}
            {this.props.item?.matrixReport && <Menu.Item onClick={(e: any) => this.onExportFormat('special')}>{t('Matrix Format')}</Menu.Item>}
            {this.props.item?.monthlyReport && <Menu.Item onClick={(e: any) => this.downloadExcel(moment().clone().startOf("month").startOf("isoWeek").startOf("day").unix(), moment().clone().endOf("month").endOf("isoWeek").endOf("day").unix(), "monthly")}>{`${t('Monthly Format')} (Lei do Bem App)`}</Menu.Item>}
            {this.props.item?.quarterlyReport && <Menu.Item onClick={(e: any) => this.downloadExcel(moment().clone().startOf("year").startOf("isoWeek").startOf("day").unix(), moment().clone().endOf("week").endOf("isoWeek").endOf("day").unix(), "quarterly")}>{`${t('Quarterly Format')} (Lei do Bem App)`}</Menu.Item>}
            {this.props.item?.anualReport && <Menu.Item onClick={(e: any) => this.downloadExcel(moment().clone().startOf("year").startOf("isoWeek").startOf("day").unix(), moment().clone().endOf("week").endOf("isoWeek").endOf("day").unix(), "anual")}>{`${t('Anual Format')} (Lei do Bem App)`}</Menu.Item>}
        </Menu>

        const stateOptions = <Menu>
            <Menu.Item onClick={(e: any) => this.onStatusFilter('all')}>{t('All')}</Menu.Item>
            <Menu.Item onClick={(e: any) => this.onStatusFilter('Draft')}>{t('Draft')}</Menu.Item>
            <Menu.Item onClick={(e: any) => this.onStatusFilter('Pending')}>{t('Pending')}</Menu.Item>
            <Menu.Item onClick={(e: any) => this.onStatusFilter('Approved')}>{t('Approved')}</Menu.Item>
            <Menu.Item onClick={(e: any) => this.onStatusFilter('Rejected')}>{t('Rejected')}</Menu.Item>
        </Menu>

        return <div>
            <Row gutter={0} >
                <Col span={2}>
                    <div data-tut="reactour__importTimesheet" style={{ padding: 0, margin: 0, width: '100%', height: '40px', zIndex: -10, position: 'relative', bottom: '-35px' }}></div>
                </Col>
                <Col span={10}>
                    <Tour
                        steps={isReadOnly(this.props.userProfile) ? steps(t).stepsTimesheetsReadOnly : steps(t).stepsTimesheets}
                        isOpen={this.state.isTourOpen}
                        onRequestClose={() => this.setIsTourOpen(false)}
                    />
                </Col>
                <Col span={12}>
                    <div style={{ float: 'right' }}>
                        <div style={{ marginBottom: 5 }}>
                            <Button
                                type={"link"}
                                data-tut="reactour__timesheetInit"
                                onClick={() => this.setIsTourOpen(true)}
                                icon={'caret-right-fill'}>
                                {t("Discover Timesheets")}
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
            <div data-tut="reactour__navegateTimesheet" style={{ padding: 0, margin: 0 }}>
                <TableView
                    showDeleteStatusWindow
                    onSelectedChange={this.onSelectChange}
                    rowKey='id'
                    model={tableModel}
                    error={this.timesheetsStore.state.result && !this.timesheetsStore.state.result.isSuccess && formatMessage(this.timesheetsStore.state.result)}
                    embedded={false}
                    onQueryChanged={(q: Query) => this.onQueryChanged(q)}
                    onRefresh={() => this.load(this.state.query)}
                    canEdit={false}
                    canDelete={!isReadOnly(this.props.userProfile)}
                    onDeleteRow={this.onDeleteRow}
                    canCreateNew={false}
                    onNewItem={this.onNewItem}                  
                    leftToolbar={
                        <>
                            <li>
                                <BulkInsertUpload
                                    bulkTemplateName={t('timesheet.xlsx')}
                                    bulkInsertUrl={isReadOnly(this.props.userProfile) ? undefined : `api/v1/admin/companies/${this.props.companyId}/timesheets/bulk_insert`}
                                    bulkTemplateUrl={isReadOnly(this.props.userProfile) ? undefined : `api/v1/admin/companies/${this.props.companyId}/timesheets/template`}
                                />
                            </li>
                            {
                                (hasSelected && this.state.selectedItems.length > 0) ? (
                                    <li>
                                        <Tooltip placement="topLeft" title={t('Download selected')}>
                                            <Button onClick={() => this.downloadExcelTimesheet("standard", '', true)}
                                                style={{ backgroundColor: 'rgb(0, 174, 255)', color: 'white' }}
                                                disabled={this.timesheetsStore.state.items.length == 0}
                                            >
                                                <Icon type='download' />
                                            </Button>
                                        </Tooltip>
                                    </li>
                                ) :
                                    <li>
                                        <Tooltip placement="topLeft" title={t('Download All')}>
                                            <Button onClick={() => this.downloadExcelTimesheet("standard", '', true)}
                                                style={{ backgroundColor: 'rgb(0, 174, 255)', color: 'white' }}
                                                disabled={this.timesheetsStore.state.items.length == 0}
                                            >
                                                <Icon type='download' />
                                            </Button>
                                        </Tooltip>
                                    </li>
                            }
                        </>                        
                    }
                    rightToolbar={
                        <ul>
                            {this.checkAuthAdmin() &&
                                <li>
                                    <EditableTooltip  name="timesheet-list-generate-btn" noIcon>
                                        <Button 
                                            disabled={this.props.item?.isInactive}
                                            style={{ "marginLeft": "5px" }}
                                            onClick={this.onGenerateTimesheetsClick}
                                            icon={'solution'}>
                                            <Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} />
                                            {t("Add timesheets")}
                                        </Button>
                                    </EditableTooltip>

                                    <Divider type="vertical" />
                                </li>

                            }
                            <li className={"customSwitch-container"}>
                                <RangePickerFilter
                                    initDates={this.state.filterDates}
                                    initalShowDates={this.state.filterDateVisible}
                                    onChange={this.onChangeDatePicker}
                                />
                            </li>
                            <li>
                                <Dropdown overlay={stateOptions}>
                                    <Button>
                                        <div style={{ marginRight: '11px', marginLeft: '11px' }}>
                                            {t(this.state.selectedStatusText)} <Icon type="down" />
                                        </div>
                                    </Button>
                                </Dropdown>
                            </li>
                            <Divider type="vertical" />
                            <li>
                                <Dropdown overlay={downloadOptions}>
                                    <Button>
                                        <div>
                                            <Icon type="download" /> <Divider type="vertical" /> {t("Get timesheets")} <Icon type="down" />
                                        </div>
                                    </Button>
                                </Dropdown>
                            </li>
                            <Divider type="vertical" />
                        </ul>}
                >
                </TableView>
                {/*this.state.newTimesheetShown && <NewTimesheetView onClose={this.onNewItemClosed} />*/}
                {this.state.configureExport && <ExportParamsView
                    onOk={() => { }}
                    onCancel={this.cancelExport}
                    onValueChange={(period) => {
                        this.downloadExcelTimesheet(this.state.exportFormat, period);
                    }}
                    defaultCustomDate={this.state.defaultCustomDate}
                    defaultValuesCustomDate={this.state.defaultValuesCustomDate}
                />}
            </div>
            {this.state.isGeneratorActive && <NewTimesheetsGeneratorView
                companyId={this.props.companyId}
                onClose={this.onGenerateTimesheetsClosed}
                onGenerated={this.onGenerated}
            />}
        </div>
    }
}
// Wire up the React component to the Redux store
export default withUserProfile(withCache(withIdentity(withRouter(withTranslation()(TimesheetsDashboard)))))
